export default __webpack_public_path__ + "static/media/gallery_06.ef650668.jpg";